export default "__VITE_ASSET__DDL$ELSl__"